module.exports = {
  assetPrefix: `/tos`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://crunchyroll.com`,
    url: `https://crunchyroll.com/tos`,
    title: `Crunchyroll Terms of Use`,
    description: `Terms of Service`,
    banner: {
      url: `https://crunchyroll.com/tos/default-banner.jpg`,
      width: `1080`,
      height: `565`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
  ],
}
